<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <div class="control">
            <h1 class="title is-5">{{detail.name}}</h1>
          </div>
          <div class="control">
            <a class="edit" @click="edit">
              <b-icon icon="pencil" size="is-small" class="icon"></b-icon>
              {{ $t('interface.edit') }}
            </a>
          </div>
        </div>
      </div>
      <b-tabs v-model="section">
        <b-tab-item :label="$t('interface.information')">
          <ProjectInformation></ProjectInformation>
        </b-tab-item>
        <b-tab-item :label="$t('projects.phases')">
          <Phases></Phases>
        </b-tab-item>
        <b-tab-item :label="$t('projects.financingSources')">
          <FinancingSources></FinancingSources>
        </b-tab-item>
        <b-tab-item :label="$t('projects.contractors')">
          <Contractors></Contractors>
        </b-tab-item>
        <b-tab-item :label="$t('projects.spending')">
          <Spending></Spending>
        </b-tab-item>
        <b-tab-item :label="$t('projects.issues')">
          <Issues></Issues>
        </b-tab-item>
      </b-tabs>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import ProjectInformation from '@/components/ProjectInformation'
  import Phases from '@/components/Phases'
  import FinancingSources from '@/components/FinancingSources'
  import Contractors from '@/components/Contractors'
  import Spending from '@/components/Spending'
  import Issues from '@/components/Issues'

  const sections = ['info', 'phases', 'financingSources', 'contractors', 'spending', 'issues']

  export default {
    components: {
      DashboardLayout,
      ProjectInformation,
      Phases,
      FinancingSources,
      Contractors,
      Spending,
      Issues
    },
    data() {
      return {
        section: 0
      }
    },
    methods: {
      edit() {
        this.$router.push({
          name: 'editProject',
          params: {projectId: this.detail.id}
        })
      }
    },
    mounted() {
      this.$store.dispatch('Project/getDetail', this.$route.params.projectId)
      this.$store.dispatch('Project/getRelations')
      this.$store.dispatch('Project/getAttachmentTypes', this.$route.params.projectId)
      if (this.$route.params.section) {
        this.section = sections.indexOf(this.$route.params.section)
      }
    },
    computed: {
      ...mapState('Project', ['detail']),
      breadcrumbs() {
        return [
          {name: 'projects', path: 'projects'},
          {name: 'projectDetail'},
        ]
      }
    },
    watch: {
      section(section) {
        this.$router.push({
          name: 'projectDetail',
          params: {
            projectId: this.$route.params.projectId,
            section: sections[section]
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .edit {
    font-size: 13px !important;
    margin-left: 10px;

    .icon {
      margin-right: 2px;
    }
  }
</style>